import { useEffect, useState } from "react";
import getClient from "../helpers/get-client";

/**
 * Pagos del médico logueado para "Mi suscripción" (item Planner #1487).
 *
 * `GET /api/billing/me/payments/` NO lleva id: el backend saca el usuario del
 * token, así que este hook no puede pedir los pagos de otra persona aunque
 * quisiera. Un fetch al montar, sin polling ni cache: los pagos cambian una
 * vez al mes.
 *
 * Fail-silent, mismo criterio que `useWeeklyUsage`: si el endpoint falla o
 * devuelve algo que no es una lista, queda `null` y el historial no se dibuja.
 * Una pantalla informativa jamás le muestra un error a quien pasa a mirar.
 * `null` = todavía no hay dato (o falló); `[]` = no tiene pagos.
 */
export default function useMyPayments() {
  const [pagos, setPagos] = useState(null);

  useEffect(() => {
    let vivo = true;
    getClient()
      .get("/api/billing/me/payments/")
      .then((res) => {
        if (vivo) setPagos(Array.isArray(res?.data) ? res.data : null);
      })
      .catch(() => {
        if (vivo) setPagos(null);
      });
    return () => {
      vivo = false;
    };
  }, []);

  return pagos;
}
